import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSFX } from 'js/hooks/useSFX';

// icons
import IconSearchActiveOption from '../icon/Icon.search-active-option';
import IconSearchImagineOption from '../icon/Icon.search-imagine-option';
import IconSearchPlayOption from '../icon/Icon.search-play-option';
import IconSearchSensoryOption from '../icon/Icon.search-sensory-option';

import IconSearchActiveOptionES from '../icon/Icon.search-active-option-es';
import IconSearchImagineOptionES from '../icon/Icon.search-imagine-option-es';
import IconSearchPlayOptionES from '../icon/Icon.search-play-option-es';
import IconSearchSensoryOptionES from '../icon/Icon.search-sensory-option-es';

// actions
import { updatePlayTypeFilter } from 'js/store/search/Search.actions';

// selectors
import { getTranslationById } from 'js/store/app/App.selectors';
import { getAvailableOptionsById } from 'js/store/search/Search.selectors';

const PLAY_TYPE_OPTIONS = [
  {
    id: 'play_type_1',
    Icon: {
      en: IconSearchActiveOption,
      es: IconSearchActiveOptionES,
    },
  },
  {
    id: 'play_type_2',
    Icon: {
      en: IconSearchSensoryOption,
      es: IconSearchSensoryOptionES,
    },
  },
  {
    id: 'play_type_3',
    Icon: {
      en: IconSearchImagineOption,
      es: IconSearchImagineOptionES,
    },
  },
  {
    id: 'play_type_4',
    Icon: {
      en: IconSearchPlayOption,
      es: IconSearchPlayOptionES,
    },
  },
];

const FindPlayTypeOptions = () => {
  const { playSFX } = useSFX();
  const [scrollTriggered, setScrollTriggered] = React.useState(false);
  const dispatch = useDispatch();
  const availablePlayTypes = useSelector((state) => getAvailableOptionsById(state, 'play_type'));

  const selectedPlayType = useSelector((state) => state?.search?.filters?.playType);

  const locale = useSelector((state) => state.app.locale);

  const title = useSelector((state) =>
    getTranslationById(state, 'find_step_2_location_title', 'Where are you playing?')
  );

  const updateSelection = useCallback(
    (playTypeId) => {
      dispatch(updatePlayTypeFilter(playTypeId));
    },
    [dispatch]
  );

  return (
    <>
      <h2 className="find__title find__play-type-title">{title}</h2>

      <ul className="find__play-type-options">
        {PLAY_TYPE_OPTIONS.map(({ id, Icon }) => {
          const isSelected = selectedPlayType.includes(id);
          const isAvailable = availablePlayTypes.includes(id);
          const IconComponent = Icon[locale] || Icon.en;
          return (
            <li key={id} className={isSelected ? 'active' : '' + (isAvailable ? '' : ' disabled')}>
              <IconComponent
                onClick={() => {
                  playSFX('button_tap');
                  if (!scrollTriggered) {
                    setScrollTriggered(true);
                    // scroll to the bottom of the page to show the new options
                    window.scrollTo({
                      top: document.documentElement.scrollHeight,
                      behavior: 'smooth',
                    });
                  }
                  isAvailable && updateSelection(id);
                }}
              />
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default FindPlayTypeOptions;
